<template>
  <div
    role="separator"
    :class="[
      'tw:bg-(--divider-color)',
      vertical ? 'tw:w-px tw:self-stretch' : 'tw:w-full tw:h-px',
    ]"
    :style="legacyStyle"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const props = withDefaults(defineProps<{
  /** Render as a vertical divider */
  vertical?: boolean
  /** @deprecated Use Tailwind classes on parent instead (e.g. tw:my-4) */
  h?: string
  /** @deprecated Use Tailwind classes on parent instead */
  height?: string
  /** @deprecated Use Tailwind classes on parent instead */
  w?: string
  /** @deprecated Use Tailwind classes on parent instead */
  width?: string
  /** @deprecated Use Tailwind classes on parent instead */
  my?: string
  /** @deprecated Use Tailwind classes on parent instead */
  mx?: string
  /** @deprecated Use Tailwind classes on parent instead */
  m?: string
  /** @deprecated Use Tailwind classes on parent instead */
  ml?: string
  /** @deprecated Use Tailwind classes on parent instead */
  mr?: string
  /** @deprecated Use Tailwind classes on parent instead */
  mt?: string
  /** @deprecated Use Tailwind classes on parent instead */
  mb?: string
  /** @deprecated Use Tailwind classes on parent instead */
  margin?: string
  /** @deprecated Use Tailwind classes on parent instead */
  marginY?: string
  /** @deprecated Use Tailwind classes on parent instead */
  marginX?: string
  /** @deprecated Use Tailwind classes on parent instead */
  marginLeft?: string
  /** @deprecated Use Tailwind classes on parent instead */
  marginRight?: string
  /** @deprecated Use Tailwind classes on parent instead */
  marginTop?: string
  /** @deprecated Use Tailwind classes on parent instead */
  marginBottom?: string
}>(), {
  vertical: false,
  h: undefined,
  height: undefined,
  w: undefined,
  width: undefined,
  my: undefined,
  mx: undefined,
  m: undefined,
  ml: undefined,
  mr: undefined,
  mt: undefined,
  mb: undefined,
  margin: undefined,
  marginY: undefined,
  marginX: undefined,
  marginLeft: undefined,
  marginRight: undefined,
  marginTop: undefined,
  marginBottom: undefined,
})

// Legacy style support — will be removed in a future version
const legacyStyle = computed(() => {
  const s: Record<string, string> = {}

  const h = props.height ?? props.h
  const w = props.width ?? props.w
  if (h) s.height = h
  if (w) s.width = w

  const marginVal = props.margin ?? props.m
  if (marginVal) s.margin = marginVal

  const ml = props.marginLeft ?? props.ml ?? props.marginX ?? props.mx
  const mr = props.marginRight ?? props.mr ?? props.marginX ?? props.mx
  const mt = props.marginTop ?? props.mt ?? props.marginY ?? props.my
  const mb = props.marginBottom ?? props.mb ?? props.marginY ?? props.my

  if (ml) s.marginLeft = ml
  if (mr) s.marginRight = mr
  if (mt) s.marginTop = mt
  if (mb) s.marginBottom = mb

  return Object.keys(s).length > 0 ? s : undefined
})
</script>
